export const EXPERIMENT_UPSELL_SURVEY = 'upsell_survey';
export const EXPERIMENT_SIGN_IN_PANEL_REDESIGN = 'sign-in-panel-redesign';
export const EXPERIMENT_VALIDATE_LD_SP = 'validate-ld-sp';

export const FF_OUTAGE_BANNER = 'we-transfer-outage-banner';
export const FF_PIXEL_TRACKING = 'marketing-pixel-tracking';
export const FF_IMPLEMENT_SPACES = 'implement-spaces';
export const FF_FORCE_ACCOUNT_VERIFICATION = 'force-account-verification';
export const FF_REMOVE_TRANSFER_DEFAULT_EXPIRY =
  'remove-transfer-default-expiry';
export const FF_COOKIE_WALL = 'cookie-wall';
export const FF_INTERCOM = 'intercom';
